export default "__VITE_ASSET__JESihFVw__"